import React, { useContext } from "react";
import "./SalesTotalByPeriodWidget.scss";
import { FormattedMessage, useIntl } from "react-intl";
import { NumericFormat } from "react-number-format";
import SalesTotalTypeEnum from "../../../models/SalesTotalTypeEnum";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import { OwIconTooltip } from "../../shared/OwIconTooltip/OwIconTooltip";
import OwLabel from "../../shared/OwLabel/OwLabel";
import SupplierContext from "../../../contexts/SupplierContext";
import SupplierService from "../../../services/SupplierService";
import UserTypesEnum from "../../../models/UserTypesEnum";

type Props = {
    type: SalesTotalTypeEnum;
    amount: number;
    removeWidget?: () => void;
    inEditor?: boolean;
};

export const SalesTotalByPeriodWidget = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const intl = useIntl();

    const fiscalYearStartMonth = SupplierService.getFiscalYearStartMonth(supplierModel);
    const showFiscalTooltip = props.type === SalesTotalTypeEnum.YEARLY && fiscalYearStartMonth !== 1;

    return (
        <div className={"SalesTotalByPeriodWidget widget"}>
            {props.inEditor ? (
                <div className={""}>
                    <OwIconButton iconClass={"fas fa-trash-alt"} iconColorClass={"text-danger"} fn={props.removeWidget!} />
                </div>
            ) : null}
            <div className={"period-title"}>
                <OwLabel title={`${props.type}_sales`} noBottomMargin={true} />
                {showFiscalTooltip ? (
                    <span className={"ms-1"}>
                        <OwIconTooltip
                            iconClassName={"fad fa-info-circle"}
                            tooltipContent={
                                <span>
                                    <FormattedMessage id={"fiscal_year_starting"} defaultMessage={"Fiscal year starting"} />{" "}
                                    {SupplierService.getFiscalYearStartLabel(fiscalYearStartMonth, intl.locale)}
                                </span>
                            }
                        />
                    </span>
                ) : null}
            </div>
            <div className={"sales-total"}>
                <NumericFormat
                    value={props.amount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                />
            </div>
        </div>
    );
};
